import clsx from "clsx";
import React, { FunctionComponent, memo } from "react";

import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";
import { ScrollControls } from "../ScrollControls/ScrollControls";
import { useHasOverflow } from "../ScrollControls/useHasOverflow";

const UncachedFooter: FunctionComponent = () => {
  const dealer = useNullableDealerAccountInfo();
  const [scrollRef, overflow] = useHasOverflow<HTMLDivElement>();
  if (!dealer) {
    return null;
  }
  const tireManufacturers = Object.values(
    dealer?.dealerProductFilters.tireManufacturers ?? {}
  );
  return (
    <div>
      <section
        className={clsx(
          "pt-10 flex items-center mt-auto px-4 overflow-auto scrollbar-hide",
          "gap-4 md:gap-8 lg:gap-16",
          "bg-paper bg-opacity-25",
          !(overflow.left || overflow.right) && "justify-center"
        )}
        id="tire-manufacturers"
        ref={scrollRef}
      >
        {tireManufacturers
          .filter(({ visibility }) => visibility === "show")
          .map(({ part_manufacturer_logo, part_manufacturer_name }) => {
            return (
              <img
                alt={part_manufacturer_name}
                className="max-w-[8rem] lg:max-w-[10rem]"
                key={part_manufacturer_logo + part_manufacturer_name}
                src={part_manufacturer_logo}
              />
            );
          })}
      </section>
      <ScrollControls overflowState={overflow} scrollRef={scrollRef} />
    </div>
  );
};

export const Footer = memo(UncachedFooter);
